import {t} from '@lingui/core/macro';

import HttpIncidentFilters from 'features/http/model/HttpIncident/IHttpIncidentFilters';
import IHttpIncidentExportRequest from 'features/http/model/HttpIncident/IHttpIncidentExportRequest';
import {IHttpIncidentFiltersForm} from 'features/http/model/HttpIncident/IHttpIncidentFiltersForm';
import {dateRangeToDateAfterBefore, dateRangeToFilters, stringToBoolean} from 'shared/lib/filterHelper';

export const DEFAULT_INCIDENT_DURATION = 3600;

export function getHttpIncidentResolvedOptions() {
    return [
        {label: t`Решен`, value: 'true'},
        {label: t`Есть проблемы`, value: 'false'},
    ];
}

export function getHttpIncidentSortOptions() {
    return [
        {label: t`Статус`, value: 'resolved'},
        {label: t`URL`, value: 'monitor.url'},
        {label: t`Период начала инцидента`, value: 'created_at'},
        {label: t`Период решения инцидента`, value: 'resolved_at'},
        {label: t`Длительность`, value: 'duration'},
    ];
}

export function formatHttpIncidentDuration(seconds: number): string {
    if (seconds < 60) {
        return `${seconds} ${t`сек`}.`;
    }
    if (seconds < 3600) {
        return `${Math.floor(seconds / 60)} ${t`мин`}.`;
    }
    return `${Math.floor(seconds / 3600)} ${t`час`}.`;
}

export function buildHttpIncidentFilters({
    // eslint-disable-next-line camelcase
    created_at,
    // eslint-disable-next-line camelcase
    resolved_at,
    // eslint-disable-next-line no-unused-vars
    orderBy,
    resolved,
    monitor,
    duration,
    ...rest
}: IHttpIncidentFiltersForm): HttpIncidentFilters {
    const data: HttpIncidentFilters = {...rest};

    data['monitor.url'] = monitor?.url;

    if (resolved !== null && resolved !== undefined) {
        data.resolved = stringToBoolean(resolved);
    }

    if (duration) {
        data.duration = duration;
    }

    dateRangeToFilters(created_at, data, 'created_at');
    dateRangeToFilters(resolved_at, data, 'resolved_at');

    return data;
}

export function buildHttpIncidentExportRequest({
    monitor,
    resolved,
    // eslint-disable-next-line camelcase
    created_at,
    // eslint-disable-next-line camelcase
    resolved_at,
    duration,
    orderBy,
}: IHttpIncidentFiltersForm): IHttpIncidentExportRequest {
    return {
        monitorUrl: monitor?.url,
        resolved: stringToBoolean(resolved),
        created_at: dateRangeToDateAfterBefore(created_at),
        resolved_at: dateRangeToDateAfterBefore(resolved_at),
        duration,
        orderBy,
    };
}
